import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2f1e683a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "搜索歌曲", -1));
const _hoisted_2 = {
  key: 0,
  class: "search_wrap"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "hot_title"
}, "热门搜索", -1));
const _hoisted_4 = {
  class: "hot_name_wrap"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 1,
  class: "search_wrap"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "hot_title"
}, "搜索结果", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_search = _resolveComponent("van-search");
  const _component_SingleSong = _resolveComponent("SingleSong");
  const _component_lazy_component = _resolveComponent("lazy-component");
  return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_component_van_search, {
    modelValue: $data.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.value = $event),
    shape: "round",
    placeholder: "搜索歌曲、歌手"
  }, null, 8, ["modelValue"]), $data.searchResultList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.hotList, (obj, index) => {
    return _openBlock(), _createElementBlock("span", {
      class: "hot_item",
      key: index,
      onClick: $event => $options.hotSearch(obj.first)
    }, _toDisplayString(obj.first), 9, _hoisted_5);
  }), 128))])])) : _createCommentVNode("", true), $data.searchResultList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createVNode(_component_lazy_component, null, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.searchResultList, obj => {
      return _openBlock(), _createBlock(_component_SingleSong, {
        key: obj.id,
        name: obj.name,
        id: obj.id,
        author: obj.artists[0].name
      }, null, 8, ["name", "id", "author"]);
    }), 128))]),
    _: 1
  })])) : _createCommentVNode("", true)], 64);
}